import { render } from "./PrivacyModal.vue?vue&type=template&id=2668813a&lang=html"
import script from "./PrivacyModal.vue?vue&type=script&lang=js"
export * from "./PrivacyModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__